query curriculumTeachingDates($scenarioId: ID!, $filter: CurriculumFilterInput!) {
  data(scenarioId: $scenarioId) {
    curriculums(filter: $filter) {
      items {
        id
        tags
      }
    }
  }
}
